// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import type { Incident } from '../types';
import { Button, Modal, Tag, severityTone } from '../ui';
import { INCIDENT_LABEL, ago, countryName, fmt } from '../format';
import { blockableSource } from '../tabs/SecurityTab';

const when = (iso: string) => {
  const t = Date.parse(iso);
  return Number.isFinite(t) ? `${new Date(t).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })} (${ago(iso)})` : '—';
};

/** Incident detail — what happened, where from, and a Block button while it is still only "watching". */
export const IncidentModal: React.FC<{ incident: Incident; siteName: string; onClose: () => void; onBlock: (source: string) => void }> = ({ incident: i, siteName, onClose, onBlock }) => {
  const canBlock = i.status === 'watching' && blockableSource(i.source);
  const rows: Array<[string, React.ReactNode]> = [
    ['Source', <span className="font-mono">{i.source}</span>],
    ['Country', i.country ? countryName(i.country) : '—'],
    ['Network', i.network || '—'],
    ['Website', i.siteName || siteName],
    ['Requests', fmt(i.hits)],
    ['First seen', when(i.firstAt)],
    ['Last seen', when(i.lastAt)],
  ];
  return (
    <Modal
      title={INCIDENT_LABEL[i.type] || i.type} badge={<Tag tone={severityTone(i.severity)}>{i.severity}</Tag>} onClose={onClose} testId="wa-incident-modal"
      footer={<>
        <Button onClick={onClose}>Close</Button>
        {canBlock && <Button tone="ruby" onClick={() => onBlock(i.source)}>Block {i.source}</Button>}
        {i.status === 'blocked' && <span className="self-center"><Tag tone="green">Already blocked</Tag></span>}
      </>}
    >
      <p className="mt-0">{i.detail}</p>
      <table className="w-full border-collapse text-[13px]">
        <tbody>
          {rows.map(([k, v]) => (
            <tr key={k}><td className="text-stone-500 py-2 pr-3 border-b border-stone-100 w-32">{k}</td><td className="py-2 border-b border-stone-100">{v}</td></tr>
          ))}
        </tbody>
      </table>
    </Modal>
  );
};

export default IncidentModal;
